import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class CartPricingLineRequest
*  
*/
export class CartPricingLineRequest extends ActiveModel {

  /**
  * productId
  *   */
  @ActiveField(0)
  productId: number = 0


  /**
  * qty
  *   */
  @ActiveField(0)
  qty: number = 0
}
